<template>
  <fieldset class="form-checkboxes-double-col-wrapper">
    <p>{{ i18nDescription }}</p>
    <div
      :class="
        'form-checkboxes-double-col ' +
          (showDayOptionsAsCurrentFutureCols ? '' : 'form-checkboxes-double-col--prevent-col')
      "
    >
      <div class="form-checkboxes-double-col__col">
        <div class="form-checkboxes-double-col__header-wrapper">
          <span class="form-checkboxes-double-col__header">{{ i18n.form.labels.day }}</span>
          <span class="form-checkboxes-double-col__header text-center">{{
            i18n.form.labels.currentSituation
          }}</span>
        </div>

        <FormulateInput
          v-model="currentDays"
          :name="namePrefix + 'CurrentDays'"
          :options="inputOptions"
          type="checkbox"
          @input="handleInputForDaySelection"
        />
      </div>
      <div class="form-checkboxes-double-col__col">
        <div class="form-checkboxes-double-col__header-wrapper">
          <arrow-right-white
            class="icon form-checkboxes-double-col__arrow"
          />
          <span class="form-checkboxes-double-col__header text-center">{{
            i18n.form.labels.futureSituation
          }}</span>
        </div>
        <FormulateInput
          v-model="futureDays"
          :name="namePrefix + 'FutureDays'"
          :options="inputOptions"
          type="checkbox"
          :validation="!isCancellationSelected ? 'required' : ''"
          :validation-messages="i18n.form.validations.days"
          @input="handleInputForDaySelection"
        />
      </div>
    </div>

    <FormulateInput
      v-if="showCancellation"
      v-model="isCancellationSelected"
      :name="namePrefix + 'Cancellation'"
      :label="i18nCancellation"
      type="checkbox"
      @input="handleInputForCancellation"
    />
  </fieldset>
</template>

<script>
export default {
  name: 'FieldsProductDays',
  components: {
    ArrowRightWhite: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ArrowRightWhite.vue'),
  },
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    i18nDescription: {
      type: String,
      default: () => '',
    },
    i18nCancellation: {
      type: String,
      default: () => '',
    },
    namePrefix: {
      type: String,
      default: () => '',
    },
    hideWednesday: {
      type: Boolean,
      default: false,
    },
    showCancellation: {
      type: Boolean,
      default: false,
    },
    showDayOptionsAsCurrentFutureCols: {
      type: Boolean,
      default: true,
    },
  },
  data: function() {
    return {
      currentDays: [],
      futureDays: [],
      isCancellationSelected: false,
    };
  },
  computed: {
    inputOptions() {
      let options = {};
      let optionsFirst = {
        monday: this.i18n.form.labels.daysoptions.monday,
        tuesday: this.i18n.form.labels.daysoptions.tuesday,
      };
      let optionsSecond = {
        thursday: this.i18n.form.labels.daysoptions.thursday,
        friday: this.i18n.form.labels.daysoptions.friday,
      };

      if (!this.hideWednesday) {
        options = {
          ...optionsFirst,
          ...{ wednesday: this.i18n.form.labels.daysoptions.wednesday },
          ...optionsSecond,
        };
      } else {
        options = { ...optionsFirst, ...optionsSecond };
      }

      return options;
    },
  },
  methods: {
    handleInputForDaySelection(days) {
      this.isCancellationSelected = false;
      this.sortSelectedDaysChronologically(days);
    },
    handleInputForCancellation(value) {
      if (value) {
        this.futureDays.splice(0, this.futureDays.length);
      }
    },
    sortSelectedDaysChronologically(days) {
      if (days) {
        const allDays = Object.keys(this.inputOptions);
        days.sort((a, b) => allDays.indexOf(a) - allDays.indexOf(b));
      }
    },
  },
};
</script>
